import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['discriminatoryField', 'searchField'];
  static values = { paramName: String };

  connect () {
    this.narrowDownOptions();
  }

  narrowDownOptions () {
    if (!this.hasDiscriminatoryFieldTarget || !this.hasSearchFieldTarget) return;

    this.searchFieldTarget.dataset.ajaxAdditionalFilters = `[["${this.paramNameValue}", "${this.discriminatoryFieldTarget.value}"]]`;
    this.searchFieldTarget.disabled = !this.discriminatoryFieldTarget.value;
    this.searchFieldTarget.dispatchEvent(new CustomEvent('reinit', {}));
  }
}
